import { forwardRef } from 'react';
import clsx from 'clsx';

const variantStyles = {
  default:
    'border border-[rgba(var(--brand),0.9)] bg-[rgb(var(--brand))] text-[rgb(var(--bg))] shadow-[0_10px_22px_rgba(var(--shadow),0.2)] hover:bg-[rgb(var(--brand-700))] hover:shadow-[0_12px_26px_rgba(var(--shadow),0.24)]',
  primary:
    'border border-[rgba(var(--brand),0.9)] bg-[rgb(var(--brand))] text-[rgb(var(--bg))] shadow-[0_10px_22px_rgba(var(--shadow),0.22)] hover:bg-[rgb(var(--brand-700))] hover:shadow-[0_12px_26px_rgba(var(--shadow),0.28)]',
  strong:
    'border border-[rgba(var(--fg),0.14)] bg-[rgba(var(--fg),0.96)] text-[rgb(var(--bg))] shadow-[0_8px_18px_rgba(var(--shadow),0.24)] hover:bg-[rgba(var(--fg),0.84)] hover:shadow-[0_10px_22px_rgba(var(--shadow),0.32)]',
  outline:
    'border border-[rgba(var(--border),0.75)] bg-[rgba(var(--panel),0.78)] text-[rgb(var(--fg))] hover:bg-[rgba(var(--subpanel),0.92)] dark:border-[rgba(var(--border),0.7)] dark:bg-[rgba(var(--panel),0.62)] dark:text-[rgb(var(--fg))] dark:hover:bg-[rgba(var(--subpanel),0.8)]',
  ghost:
    'bg-transparent text-[rgb(var(--fg))] hover:bg-[rgba(var(--brand),0.08)] dark:text-[rgb(var(--fg))] dark:hover:bg-[rgba(var(--brand),0.16)]',
  success:
    'border border-[rgba(var(--brand),0.78)] bg-[rgba(var(--brand),0.88)] text-[rgb(var(--bg))] hover:bg-[rgb(var(--brand-700))]',
  danger:
    'border border-[rgba(var(--brand-700),0.78)] bg-[rgb(var(--brand-700))] text-[rgb(var(--bg))] hover:bg-[rgba(var(--brand-700),0.88)]',
};

const sizeStyles = {
  sm: 'h-8 px-3 text-sm',
  md: 'h-10 px-4 text-sm',
  lg: 'h-12 px-6 text-base',
  icon: 'h-10 w-10 p-0',
};

export const Button = forwardRef(function Button(
  { className, children, variant = 'default', size = 'md', asChild = false, ...props },
  ref,
) {
  const Component = asChild ? 'span' : 'button';
  return (
    <Component
      ref={ref}
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-xl font-semibold tracking-tight transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent disabled:pointer-events-none disabled:border-[rgba(var(--border),0.65)] disabled:bg-[rgba(var(--subpanel),0.58)] disabled:text-[rgba(var(--muted),0.88)] disabled:shadow-none',
        variantStyles[variant] || variantStyles.default,
        sizeStyles[size] || sizeStyles.md,
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
});

export default Button;
